import I18n from 'I18n';
import { PercentageStepper } from 'foundations-components/transitional/components/PercentageStepper';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import styled from 'styled-components';

// We need to override the font-size of the input because it defaults to 14px
// which is too large for the toolbar components
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledStepperWrapper = styled.div.withConfig({
  displayName: "steppers__StyledStepperWrapper",
  componentId: "sc-1uil2o4-0"
})(({
  theme
}) => ({
  '& input': {
    blockSize: '32px',
    fontSize: theme.typography['body-100'].fontSize
  }
}));
const PixelStepperFormatter = val => val != null ? `${I18n.formatNumber(val, {
  precision: 1
})}px` : '';
export function SplitStepperInput(props) {
  return /*#__PURE__*/_jsx(StyledStepperWrapper, {
    children: /*#__PURE__*/_jsx(StepperInput, Object.assign({}, props, {
      blockSize: "32px"
    }))
  });
}
export function PercentageStepperInput(props) {
  return /*#__PURE__*/_jsx(StyledStepperWrapper, {
    children: /*#__PURE__*/_jsx(PercentageStepper, Object.assign({}, props, {
      blockSize: "32px"
    }))
  });
}
export function PixelStepperInput(props) {
  return /*#__PURE__*/_jsx(SplitStepperInput, Object.assign({}, props, {
    formatter: PixelStepperFormatter
  }));
}